<style scoped lang="scss" type="text/scss">

</style>

<template>
    <el-dialog title="正在添加参赛成员"
               :visible.sync="visibleSync"
               :close-on-click-modal="false"
               @closed="reset"
               width="70%">
        <el-form ref="form" :model="memberInfo" :rules="rules" label-width="100px">
            <el-form-item label="参赛队名称" prop="player_id">
                <registrable-manged-player-selector disabled></registrable-manged-player-selector>
            </el-form-item>
            <el-form-item label="搜索人员" prop="personal_id">
                <user-search-box v-model="memberInfo.personal_id"></user-search-box>
            </el-form-item>

            <el-form-item style="margin-bottom: 0;">
                <el-button type="primary" plain @click="create()" :loading="requesting">确认</el-button>
                <el-button @click="cancel()">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
    import UserSearchBox from '../../../sub-components/user-search-box/index';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            UserSearchBox,
            RegistrableMangedPlayerSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            visible (visible) {
                this.visibleSync = visible;
            },
            visibleSync (visibleSync) {
                this.$emit('update:visible', visibleSync);
            },
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    this.memberInfo.player_id = currentManagedPlayerId;
                }
            }
        },
        data () {
            return {
                requesting: false,
                visibleSync: null,
                memberInfo: {
                    player_id: null
                },
                rules: {
                    player_id: [
                        {required: true, message: '参赛队不能为空', trigger: 'blur'}
                    ],
                    personal_id: [
                        {required: true, message: '成员不能为空', trigger: 'blur'}
                    ]
                }
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            })
        },
        methods: {
            create () {
                this.$refs.form.validate((valid) => {
                    if (!valid) return false;
                    const memberInfo = this.memberInfo;
                    this.$normalRequest('player/addMember', memberInfo, '成员添加成功', true, this, 'requesting').then(_ => {
                        this.afterSuccess();
                    }).catch(_ => {
                    });
                });
            },
            cancel () {
                this.visibleSync = false;
            },
            afterSuccess () {
                this.$emit('need-reload');
                this.reset();
            },
            reset () {
                this.$refs.form.clearValidate();
                this.$refs.form.resetFields();
                this.cancel();
            }
        }
    };
</script>
